import classes from "./page-section.module.sass";
import cn from "classnames";
import React, { ComponentPropsWithoutRef, forwardRef } from "react";

export type PageSectionProps = ComponentPropsWithoutRef<"section">;

export const PageSection = forwardRef<HTMLElement, PageSectionProps>(
  (props, ref) => {
    const { children, className, ...rest } = props;
    return (
      <section ref={ref} className={cn(classes.section, className)} {...rest}>
        {children}
      </section>
    );
  },
);
